
import { fetchLegals } from '@/assets/scripts/api'
import PageData from '@/mixins/PageData'

export default {
  name: 'PageLegals',

  mixins: [PageData],

  async asyncData() {
    return { apiData: await fetchLegals() }
  },
}
